define('adminUserGroupsListRowToolsView',[
  'module',
  'tableFieldView',
  'template!adminUserGroupsListRowToolsView'
], function (
  Module,
  FieldView,
  Tpl
) {
  'use strict';

  // Empty row-tools cell. Rows are clicked directly (see list/view.js onRowClick)
  // to open the edit popup, so no per-row action buttons are needed.
  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'admin-user-groups-list-row-tools-view table-field-view'
  });
});

